import { Controller } from "@hotwired/stimulus";

/**
 * Role selector controller for the user checkpoint flow.
 * Hides/shows the event role dropdown based on whether Administrator is selected
 * in the org role dropdown.
 */
export class RoleSelectorController extends Controller {
  static values = { descriptions: Object, adminRoleId: String };

  connect() {
    this.orgRoleSelect = this.element.querySelector("#role_id");
    this.eventRoleSelect = this.element.querySelector("#event_role_id");
    this.eventRoleWrapper = this.eventRoleSelect?.closest(".FormControl");

    if (this.orgRoleSelect) {
      this._handleOrgRoleChange = () => this.updateVisibility();
      this.orgRoleSelect.addEventListener("change", this._handleOrgRoleChange);
      this.updateVisibility();
    }

    if (this.eventRoleSelect) {
      this._handleRoleChange = () => this.updateDescription();
      this.eventRoleSelect.addEventListener("change", this._handleRoleChange);
    }
  }

  disconnect() {
    if (this.orgRoleSelect && this._handleOrgRoleChange) {
      this.orgRoleSelect.removeEventListener(
        "change",
        this._handleOrgRoleChange
      );
    }
    if (this.eventRoleSelect && this._handleRoleChange) {
      this.eventRoleSelect.removeEventListener(
        "change",
        this._handleRoleChange
      );
    }
  }

  updateVisibility() {
    if (!this.orgRoleSelect) return;

    const isAdmin = this.orgRoleSelect.value === this.adminRoleIdValue;

    if (this.eventRoleWrapper) {
      this.eventRoleWrapper.hidden = isAdmin;
    }
  }

  updateDescription() {
    if (!this.eventRoleSelect || !this.eventRoleWrapper) return;

    const caption = this.eventRoleWrapper.querySelector(".FormControl-caption");
    if (caption) {
      caption.textContent =
        this.descriptionsValue[this.eventRoleSelect.value] || "";
    }
  }
}
